import { all, call, select } from 'redux-saga/effects';
import * as pageStateService from '../page-state/page-state.saga-services';
import * as pageInitializerService from '../page.initializer.saga-service';
import * as calendarService from '../page-storage/calendars/calendars.saga-services';
import * as taskService from '../page-storage/tasks-simple/tasks-simple.saga-services';
import { authSelectors } from '../../auth/auth.selectors';
import { CURRENT_DATE } from '../../resource/calendar/calendar.types';
import { IUser } from '../../resource/user/user.types';
import { IMeeting } from '../../resource/meeting/meeting.types';
import { setupBoards } from '../page-storage/boards/boards.saga-services';
import * as settingsService from '../../resource/settings/settings.saga-service';
import * as annualsService from '../../resource/annuals/annuals.saga-service';
import * as personalNotesService from '../page-storage/personal-notes/personal-notes.saga-services';
import * as userSettingsService from '../page-storage/user-settings/user-settings.saga-services';
import { searchUserTenants } from '../../resource/user-tenants/user-tenants.saga-services';

export function* initialHomePage() {
  yield call(pageStateService.initPage, 'home');

  const currentId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
  yield call(initHomePageElements, currentId);
}

export function* initHomePageElements(currentId: IUser['id']) {
  yield all([
    call(taskService.setupTasksSimple, currentId),
    call(pageInitializerService.initPage),
    call(searchUserTenants),
    call(userSettingsService.getUserSettings),
    call(calendarService.setupCalendar, CURRENT_DATE, 'day'),
    call(settingsService.searchSettings),
    call(annualsService.getAnnuals),
    call(personalNotesService.setupPersonalNotes),
  ]);
  yield call(pageStateService.completedInit, 'home');
}
export function* initialBoardsHomePage(meetingId: IMeeting['id']) {
  yield call(setupBoards, meetingId);
}
